/**
 * Generated by orval 🍺
 * Do not edit manually.
 * FastAPI
 * OpenAPI spec version: 0.1.0
 */
import type { EventKindKind } from './eventKindKind';
import type { EventKindMinCapacity } from './eventKindMinCapacity';
import type { EventKindMinDurationMin } from './eventKindMinDurationMin';
import type { EventKindMaxDurationMin } from './eventKindMaxDurationMin';
import type { EventKindMinCapacityOverride } from './eventKindMinCapacityOverride';
import type { EventKindMaxCapacityOverride } from './eventKindMaxCapacityOverride';
import type { EventKindPlanning } from './eventKindPlanning';
import type { EventKindRequiresRecording } from './eventKindRequiresRecording';
import type { EventKindRequiresEvaluation } from './eventKindRequiresEvaluation';
import type { EventKindSendParticipantReminderHoursBefore } from './eventKindSendParticipantReminderHoursBefore';
import type { EventKindSendLecturerReminderHoursBefore } from './eventKindSendLecturerReminderHoursBefore';
import type { EventKindAllowedTimeStart } from './eventKindAllowedTimeStart';
import type { EventKindAllowedTimeEnd } from './eventKindAllowedTimeEnd';
import type { EventKindLecturerRoleLabel } from './eventKindLecturerRoleLabel';
import type { EventKindRequiredFeatureFlag } from './eventKindRequiredFeatureFlag';
import type { EventKindOralExamDefaults } from './eventKindOralExamDefaults';
import type { EventKindConductedBy } from './eventKindConductedBy';
import type { EventKindStartAuthority } from './eventKindStartAuthority';
import type { EventKindVideoProvider } from './eventKindVideoProvider';

export interface EventKind {
  id: string;
  label: string;
  /** Pedagogical classification of this event kind. Used by clients to filter event-kind pickers (e.g. the oral-exam tab only shows kinds with kind=='oral_exam'). Decouples behavior from substring/prefix checks on the ``id``. */
  kind?: EventKindKind;
  /**
   * @minimum 15
   * @maximum 1000
   */
  durationMin: number;
  minCapacity?: EventKindMinCapacity;
  /** @minimum 1 */
  maxCapacity: number;
  /** Whether lecturers may override duration per slot for this event kind. */
  allowCustomDuration?: boolean;
  /** Whether lecturers may override capacity per slot for this event kind. */
  allowCustomCapacity?: boolean;
  /** Optional minimum duration (minutes) allowed for slot-level overrides. */
  minDurationMin?: EventKindMinDurationMin;
  /** Optional maximum duration (minutes) allowed for slot-level overrides. */
  maxDurationMin?: EventKindMaxDurationMin;
  /** Optional minimum capacity allowed for slot-level overrides. */
  minCapacityOverride?: EventKindMinCapacityOverride;
  /** Optional maximum capacity allowed for slot-level overrides. */
  maxCapacityOverride?: EventKindMaxCapacityOverride;
  deprecated?: boolean;
  planning: EventKindPlanning;
  /** Whether the event kind requires recording */
  requiresRecording?: EventKindRequiresRecording;
  /** Whether slots must be explicitly bound to a task (True) or can be shared via generic pool (False) */
  requiresTaskBinding?: boolean;
  /** Whether completing this event task triggers module auto-submission */
  autosubmitModuleOnCompletion?: boolean;
  /** When True (default), module auto-submission only fires if all other module tasks are also done. When False, completing this event task submits the module immediately regardless of other tasks. Only relevant when autosubmit_module_on_completion=True. */
  autosubmitRequiresAllTasksDone?: boolean;
  /** Whether to send lecturer briefing emails for this event kind (e.g., group study sessions benefit from briefings, but quick 1:1 consultations may not) */
  sendBriefing?: boolean;
  /** Whether access to task delivery must be manually opened and closed by lecturer. */
  requiresManualRelease?: boolean;
  /** Whether tasks of this event kind require lecturer evaluation */
  requiresEvaluation?: EventKindRequiresEvaluation;
  /** If set, send reminder emails to participants N hours before the session (1-168 hours = 1 week). If None, no reminders are sent. */
  sendParticipantReminderHoursBefore?: EventKindSendParticipantReminderHoursBefore;
  /** If set, send a lightweight reminder email to the lecturer N hours before the session. Mutually exclusive with send_briefing: if send_briefing=True this field is ignored since the richer briefing email already covers the notification need. */
  sendLecturerReminderHoursBefore?: EventKindSendLecturerReminderHoursBefore;
  /** Earliest allowed UTC start time for slots of this event kind (e.g., 09:00) */
  allowedTimeStart?: EventKindAllowedTimeStart;
  /** Latest allowed UTC end time for slots of this event kind (e.g., 18:00) */
  allowedTimeEnd?: EventKindAllowedTimeEnd;
  /** Role title for the lecturer (e.g., 'Oral Examiner', 'Workshop Lead'). If None, defaults to label. */
  lecturerRoleLabel?: EventKindLecturerRoleLabel;
  /** Optional user feature flag required to create slots or bind tasks to this event kind. When None, the event kind is available to all permitted users. */
  requiredFeatureFlag?: EventKindRequiredFeatureFlag;
  oralExamDefaults?: EventKindOralExamDefaults;
  /**
   * Minimum connected supervisors required to start a multi-supervisor oral exam. Default 1 preserves today's single-supervisor behaviour.
   * @minimum 1
   */
  minSupervisors?: number;
  /** Stored on the meeting type. Graded exams ignore it: slot size decides. A dry run stays the AI examiner because it is self-service, not because of this field. */
  conductedBy?: EventKindConductedBy;
  /** Who may start the exam session. None = lecturer. self_service = the booked student starts their own session. */
  startAuthority?: EventKindStartAuthority;
  /** Which video meeting provider to use for slots of this event kind. When None, falls back to `appointment_integrations.default_video_provider`. This is the source of truth for NEW slots; once a slot is provisioned the provider is stamped onto the slot and never re-resolved (see §10.3 of the oral-exam-livekit-v1 spec). */
  videoProvider?: EventKindVideoProvider;
}
